import React, { FC } from 'react'
import NextError from 'next/error'

import { GetStaticProps } from '../redux/types'
import { getLanguageFromLocale, getMessagesFromLanguage } from '../i18n/utils'
import { getDomainFromLanguage } from '../utils/request-utils'
import { PageProps } from '../common/types'
import { getRoutesFromDomain } from '../routes/utils'

type Props = {
    title?: string
} & PageProps

const Custom404Page: FC<Props> = ({ title }) => {
    return <NextError statusCode={404} title={title} />
}

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
    const language = getLanguageFromLocale(locale)
    const domain = getDomainFromLanguage(language)
    return {
        props: {
            requestUserConfig: { domain, language },
            messages: await getMessagesFromLanguage(language),
            routes: await getRoutesFromDomain(domain),
        },
    }
}

export default Custom404Page
